import useApi from '../api';

const useEnterpriseService = () => {
    const { api } = useApi();

    return {
        sendInvite: (data) =>
            api
                .post('enterprise/invite', data, {
                    headers: { 'Content-Type': 'application/json' }
                })
                .then((resp) => resp.data),

        getEnterpriseInviteUser: (token) => api.get(`enterprise/invite/${token}`),

        getEnterpriseEmployees: (idEnterprise, currentUserRole) =>
            api.get(`enterprise/${idEnterprise}/employees`, {
                params: {
                    currentUserRole
                }
            }),

        getEnterpriseEmployeesByType: (
            idEnterprise,
            roleId,
            currentUserRole,
            page = 1,
            perPage = 10,
            search = null,
            blocked = null,
            month = null,
            year = null
        ) =>
            api.get(`enterprise/${idEnterprise}/employees-by-type`, {
                params: {
                    roleId,
                    currentUserRole,
                    page,
                    perPage,
                    search,
                    blocked,
                    month,
                    year
                }
            }),

        getEnterpriseEmployeeById: (idEnterprise, idEmployee) => api.get(`enterprise/${idEnterprise}/employees/${idEmployee}`),

        getEnterpriseConsultats: (idEnterprise, currentUserRole) =>
            api.get(`enterprise/${idEnterprise}/consultants_enterprise?currentUserRole=${currentUserRole}`).then((resp) => resp.data),

        getEnterpriseArchivedEmployees: (idEnterprise) => api.get(`enterprise/${idEnterprise}/employees-archived`),

        approveOrArchiveEmployees: (idEnterprise, idEmployee, data) =>
            api.put(`enterprise/${idEnterprise}/employee-approve-archive/${idEmployee}`, data, {
                headers: { 'Content-Type': 'application/json' }
            }),

        updateEmployee: (idUser, data) =>
            api.post(`user/${idUser}`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }),

        updateClosingDay: (idEnterprise, day) => api.post(`enterprise/${idEnterprise}/closing-day/${day}`),

        getEnterprisePerId: (id) => api.get(`enterprise/${id}`).then((resp) => resp.data),
        search: (search, page = 1, perPage = 10, segment) =>
            api
                .get('enterprise', {
                    params: {
                        search,
                        page,
                        per_page: perPage,
                        segment: segment
                    }
                })
                .then((resp) => resp.data),

        getEnterpriseEmployeesInvites: (idEnterprise, page = 1, perPage = 10, search = null, month = null, year = null) =>
            api.get(`${idEnterprise}/enterprise-invites`, {
                params: {
                    page,
                    perPage,
                    search,
                    month,
                    year
                }
            }),
        removeEmplyeeInvite: (id) => api.delete(`enterprise-invite/${id}`).then((resp) => resp),
        getGeneralData: (id, currentUserRole = null) =>
            api.get(`enterprise/${id}/general?currentUserRole=${currentUserRole}`).then((resp) => resp),
        getPropertyCountPerConsultant: (id, year, filterPerAllOrBlocked) =>
            api
                .get(`enterprise/${id}/get_property_count`, {
                    params: {
                        year,
                        filterPerAllOrBlocked
                    }
                })
                .then((resp) => resp.data)
    };
};

export default useEnterpriseService;
